/**
 * The amount of the library available for free users.
 * Used on various pages and in several upsells.
 */

export const LIBRARY_FREE_PERCENTAGE = '25%';

/** The amount of the library that is premium-only. */
export const LIBRARY_PREMIUM_PERCENTAGE = '75%';

/**
 * Placeholder token used in API/Retool-supplied plan benefit copy, swapped for
 * {@link LIBRARY_FREE_PERCENTAGE} at render time. Kept beside the value so the
 * two stay in sync.
 */
export const LIBRARY_FREE_PERCENTAGE_TOKEN = '{LIBRARY_FREE_PERCENTAGE}';
